import { getTableName } from "drizzle-orm";

import { adminsTable } from "./adminsSchema";
import { auditTrailsTable } from "./auditTrailsSchema";
import { brokersTable } from "./brokersSchema";
import { cesSurveysTable } from "./cesSurveysSchema";
import { clinicProvidersTable } from "./clinicProvidersSchema";
import { clinicsHealthPlansTable } from "./clinicsHealthPlansSchema";
import { clinicsPatientsTable } from "./clinicsPatientsSchema";
import { clinicsTable } from "./clinicsSchema";
import { consentDocumentSignaturesTable } from "./consentDocumentSignaturesSchema";
import { consentDocumentsTable } from "./consentDocumentsSchema";
import { consentsTable } from "./consentsSchema";
import { coverageCheckServiceTypesTable } from "./coverageCheckServiceTypeSchema";
import { coverageChecksTable } from "./coverageChecksSchema";
import { documentCategoriesTable } from "./documentCategoriesSchema";
import { eligibilityCategoriesTable } from "./eligibilityCategoriesSchema";
import { eligibilityResultsTable } from "./eligibilityResultsSchema";
import { fplConstantsTable } from "./fplConstantsSchema";
import { healthPlansTable } from "./healthPlansSchema";
import { householdMemberDocumentsTable } from "./householdMemberDocumentsSchema";
import { householdMemberRelationshipsTable } from "./householdMemberRelationshipsSchema";
import { householdMembersTable } from "./householdMembersSchema";
import { householdsTable } from "./householdsSchema";
import { npsSurveysTable } from "./npsSurveysSchema";
import { patientConsentsTable } from "./patientConsentsSchema";
import { patientShortCodesTable } from "./patientShortCodesSchema";
import { patientsTable } from "./patientsSchema";
import { patientUploadedFilesTable } from "./patientUploadedFilesSchema";
import { redeterminationsTable } from "./redeterminationsSchema";
import { representativesTable } from "./representativesSchema";
import { workRequirementDocumentsTable } from "./workRequirementDocumentsSchema";
import { workRequirementHouseholdMembersTable } from "./workRequirementHouseholdMembersSchema";
import { workRequirementsTable } from "./workRequirementsSchema";
import { workRequirementUsStateRulesTable } from "./workRequirementUsStateRulesSchema";

export * from "./adminsSchema";
export * from "./commonSchema";
export * from "./clinicsSchema";
export * from "./clinicsPatientsSchema";
export * from "./clinicProvidersSchema";
export * from "./healthPlansSchema";
export * from "./clinicsHealthPlansSchema";
export * from "./documentCategoriesSchema";
export * from "./patientsSchema";
export * from "./householdsSchema";
export * from "./householdMembersSchema";
export * from "./householdMemberDocumentsSchema";
export * from "./patientUploadedFilesSchema";
export * from "./consentDocumentsSchema";
export * from "./consentDocumentSignaturesSchema";
export * from "./applicationsSchema";
export * from "./applicationMembersSchema";
export * from "./householdMemberRelationshipsSchema";
export * from "./fplConstantsSchema";
export * from "./eligibilityCategoriesSchema";
export * from "./eligibilityResultsSchema";
export * from "./patientShortCodesSchema";
export * from "./auditTrailsSchema";
export * from "./coverageChecksSchema";
export * from "./redeterminationsSchema";
export * from "./coverageCheckServiceTypeSchema";
export * from "./consentsSchema";
export * from "./patientConsentsSchema";
export * from "./npsSurveysSchema";
export * from "./cesSurveysSchema";
export * from "./brokersSchema";
export * from "./representativesSchema";
export * from "./workRequirementUsStateRulesSchema";
export * from "./workRequirementsSchema";
export * from "./workRequirementHouseholdMembersSchema";
export * from "./workRequirementDocumentsSchema";

// ! Update this array as new tables are added
export const allTables = [
  adminsTable,
  clinicProvidersTable,
  clinicsHealthPlansTable,
  clinicsPatientsTable,
  clinicsTable,
  healthPlansTable,
  coverageCheckServiceTypesTable,
  coverageChecksTable,
  documentCategoriesTable,
  householdMemberDocumentsTable,
  householdMembersTable,
  householdsTable,
  patientsTable,
  patientUploadedFilesTable,
  consentDocumentsTable,
  consentDocumentSignaturesTable,
  householdMemberRelationshipsTable,
  fplConstantsTable,
  eligibilityCategoriesTable,
  eligibilityResultsTable,
  patientShortCodesTable,
  auditTrailsTable,
  redeterminationsTable,
  consentsTable,
  patientConsentsTable,
  npsSurveysTable,
  cesSurveysTable,
  brokersTable,
  representativesTable,
  workRequirementUsStateRulesTable,
  workRequirementsTable,
  workRequirementHouseholdMembersTable,
  workRequirementDocumentsTable,
].map(getTableName);

export type DBTablesType = (typeof allTables)[number];
